import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { images } from "../../../action/customFn";
import LoginFormNew from "./components/LoginFormNew";
import GoogleAuthComponent from "../GoogleAuth";
import { Link, useNavigate } from "react-router-dom";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import { AnimatePresence, motion } from "framer-motion";
import VerifyOTPForm from "./components/VerifyOTPForm";
import NewPasswordForm from "./components/NewPasswordForm";

function ForgotPassword() {
  const navigate = useNavigate();
  const [googleError, setGoogleError] = useState({ error: false, msg: "" });
  const [formStage, setFormStage] = useState(null);

  return (
    <>
      <AnimatePresence>
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="authroot-illustration-wr"
        >
          <img src={"/login-hero-banner3.jpg"} alt="" />
          <p
            onClick={() => {
              navigate("/login");
            }}
            className="back"
          >
            <FaArrowLeft /> Back To Login
          </p>
        </motion.section>
        <motion.section
          key={"forgot-password-parent"}
          className="authroot-form-wr"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <figure style={{}}>
            <img src={images["MetBrains_learning_transparent.svg"]} alt="" />
          </figure>
          <h1>Forgot Password</h1>
          <p>Reset your password using OTP</p>
          <p> which is sent to your registered email.</p>
          {formStage === null && (
            <ForgotPasswordForm
              setFormStage={setFormStage}
              googleError={googleError}
            />
          )}
          {formStage === "VERIFY__OTP" && (
            <VerifyOTPForm
              setFormStage={setFormStage}
              googleError={googleError}
            />
          )}
          {formStage === "UPDATE__PASSWORD" && (
            <NewPasswordForm
              setFormStage={setFormStage}
              googleError={googleError}
            />
          )}

          {/* <div className="forgot-password"><Link to={"/login/forgot-password"}><p>Back to Sign In</p></Link></div> */}
          {/* <div className="or-divider"><span>OR</span></div>
        <div className="options-tray">
          <GoogleAuthComponent navigate={navigate} setGoogleError={setGoogleError} />
        </div> */}
        </motion.section>
      </AnimatePresence>
    </>
  );
}

export default ForgotPassword;
